export default "__VITE_ASSET__CRr7GL7k__"